import { cn } from "@newxsystems/shared";
import { TootFooterNav } from "../../../../modules/navigation/components/TootFooterNav/TootFooterNav";
import type { IFooterBlockProps } from "./FooterBlock.props";

export const FooterBlock = ({
  contact,
  copyright,
  description,
  groups,
  legalLinks,
  logo,
  parentClass,
  socialLinks,
}: IFooterBlockProps) => {
  const hasContent = Boolean(
    logo ||
    description ||
    groups?.length ||
    socialLinks?.length ||
    contact?.email ||
    contact?.phone ||
    contact?.address ||
    legalLinks?.length ||
    copyright,
  );

  if (!hasContent) {
    return null;
  }

  return (
    <footer
      className={cn(
        "toot-heat-section border-t border-toot-grid bg-toot-black text-toot-foreground",
        parentClass,
      )}
    >
      <TootFooterNav
        contact={contact}
        copyright={copyright}
        description={description}
        groups={groups}
        legalLinks={legalLinks}
        logo={logo}
        socialLinks={socialLinks}
      />
    </footer>
  );
};

FooterBlock.displayName = "Block::FooterBlock";
